<template>
        <div class="tel-skillgroup-edit">
            <el-form :rules="modelData.rules" :model="modelData"  ref="form">
               	<table-pagination ref="tableItem" :data="modelData.tableData" :column="modelData.column">
                   <!-- 周 星期 -->
                    <template v-slot:workdayWeek="{row,$index}">
                        <el-form-item :prop="'tableData.' + $index + '.workdayWeek'" :rules="modelData.rules.workdayWeek">
                               	<el-cascader size="mini" :show-all-levels="false"  :options="options"  style="width: 100%;"
                                    :props="props"  clearable v-model="row.workdayWeek" 
                                    @change="(val)=>csacaderScopeChange(val,row)" :disabled="row.disabled"></el-cascader>
                        </el-form-item>
			         </template>
                      <!-- 时间 -->
                     <template v-slot:time="{row,$index}">
                       <el-form-item :prop="'tableData.' + $index + '.time'" :rules="modelData.rules.time">
                             <el-time-picker is-range size="mini"
                                style="width: 100%;"
                                format="HH:mm"
								value-format="HH:mm"
                                v-model="row.time"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围"
								:disabled="row.disabled">
                            </el-time-picker>
                        </el-form-item>
                     </template>
                     <!-- 日期 -->
                     <template v-slot:date="{row,$index}">
                       <el-form-item :prop="'tableData.' + $index + '.date'" :rules="modelData.rules.date">
                           <el-date-picker
                           format="yyyy-MM-dd HH:mm:ss" 
                           value-format="yyyy-MM-dd HH:mm:ss"
                            style="width:100%"
                            v-model="row.date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
							:disabled="row.disabled">
                            </el-date-picker>
                        </el-form-item>
                     </template>
                     <!-- 备注 -->
                     <template v-slot:remark="{row,$index}">
                       <el-form-item :prop="'tableData.' + $index + '.reamrk'" :rules="modelData.rules.remark">
                            <el-input :disabled="row.disabled" maxlength="20" show-word-limit placeholder="请输入内容" v-model="row.remark" clearable></el-input>
                        </el-form-item>
                     </template>
                     <!-- 文件 -->
                      <template v-slot:file="{row,$index}">
                       <el-form-item :prop="'tableData.' + $index + '.file'" :rules="modelData.rules.file" class="upload-demo-item">
                           <el-upload 
								style="width: 100%;"
						        :disabled="row.disabled"
                                class="upload-demo"
								:http-request="(res) => { return httpRequestFile(res, row)}"
								:show-file-list="false"
                                action="">
								<el-button :disabled="row.disabled" size="small" type="primary" v-if="row.file == ''">点击上传</el-button>
                                <p v-else @click.stop="">
									<el-tag :closable="!row.disabled"  @close="handleClose(row)" >
									  {{row.file.name || row.file}}
									</el-tag>
								</p>
                                <!-- <div slot="tip" class="el-upload__tip">只能上传wav文件，且不超过500kb</div> -->
                            </el-upload>
                        </el-form-item>
                     </template>
                     <!-- 操作 -->
                     <template v-slot:action="{row,$index}">
							<el-button type="text" @click="onEdit(row)" v-if="row.disabled">编辑</el-button>
                            <el-button type="text" @click="onSave(row)" :loading="modelData.loading" v-else>保存</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button type="text" @click="onDelete(row,$index)">删除</el-button>
                     </template>
                 </table-pagination>
            </el-form>
           <el-button size="mini" type="primary" plain icon="el-icon-plus" style="margin-top: 17px;" @click="onAdd">添加时间策略</el-button>
        </div>
</template>
<script>
import {cascader_week,day_data} from '../data.js'
export default {
    props:['modelData','current_row'],
    data(){
        return {
            options:cascader_week,
            props:{
				 multiple:true,
			},
            shareScopeEnd:[],
        }
    },
    methods: {
        onDelete (row,index) {
			if(!row.id) return this.modelData.tableData.splice(index,1);
            this.$confirm('此操作将永久删除当条时间策略？, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: "warning",
		   }).then(() => {
			   if(this.modelData.type == 'workday'){
				   this.$api.apiDeleteWorkdayListForSystem({
						id:row.id
				   }).then(res => {
						if(res.errcode != 0) return;
						this.$notify.success('删除成功');
						this.modelData.tableData.splice(index,1);
						this.$emit('getList')
				   })
				   return;
			   }
			   this.$api.apiDeleteHolidayListForSystem({
				   id:row.id
			   }).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success('删除成功');
					this.modelData.tableData.splice(index,1);
					this.$emit('getList')
			   })
				
		   }).catch(()=>{
			   
		   })
        },
		onEdit(row){
			let index = this.modelData.tableData.findIndex(el => !el.disabled);
			if(index != -1) return this.$notify.warning('请先保存您正在编辑的数据');
			row.disabled = false;
		},
        onSave (row) {
            this.$refs["form"].validate((valid,model)=>{
               if(valid){
				   this.$emit('updateModel',{
				   	key:'loading',
				   	loading:true,
				   	type:this.modelData.type
				   })
				   switch (this.modelData.type){
				   	case 'workday':
				   		this.onSubmitWorkday(row);
				   		break;
				   	case 'holiday':
				   	case 'exceptionday':
						this.onSubmitHoliday(row);
				   		break;
				   }
			   }
            })
        },
		onSubmitWorkday(row){
			let params = {
				beginTime:row.time?.length > 0 ? row.time[0] : '',
				brand:this.$store.state.user.brandId,
				endTime:row.time?.length > 0 ? row.time[1] : '',
				skillgroup:this.current_row.skillGroup,
				workdayWeek:this.getWorkdayWeek(row.workdayWeek)
			}
			if(row.id){
				params.id = row.id;
				this.$api.apiUpdateWorkdayListForSystem(params).then(res => {
					this.$emit('updateModel',{
						key:'loading',
						loading:false,
						type:this.modelData.type
					})
					if(res.errcode != 0) return;
					row.disabled = true;
					this.$notify.success('修改成功');
				})
				return;
			}
			this.$api.apiAddWorkdayListForSystem(params).then(res => {
				this.$emit('updateModel',{
					key:'loading',
					loading:false,
					type:this.modelData.type
				})
				if(res.errcode != 0) return;
				row.disabled = true;
				this.$notify.success('新增成功');
				this.$emit('getList');
				this.$emit('getWorkDayList')
			})
			
		},
		onSubmitHoliday(row){
			let params = {
				beginTime:row.date?.length > 0 ? row.date[0] : '',
				brand:this.$store.state.user.brandId,
				endTime:row.date?.length > 0 ? row.date[1] : '',
				skillgroup:this.current_row.skillGroup,
				holidayType:this.modelData.type == 'holiday' ? '0' : '1'
			}
			const formData = new FormData();
			Object.keys(params).map(item => {
				formData.append(item,params[item])
			})
			if(this.modelData.type == 'holiday' && row.file.name){
				formData.append('file', row.file);
			}
			if(row.id){
				formData.append('id', row.id);
				this.$api.apiUpdateHolidayListForSystem(formData).then(res => {
					this.$emit('updateModel',{
						key:'loading',
						loading:false,
						type:this.modelData.type
					})
					if(res.errcode != 0) return;
					row.disabled = true;
					this.$notify.success('修改成功');
				})
				return;
			}
			this.$api.apiAddHolidayListForSystem(formData).then(res => {
				this.$emit('updateModel',{
					key:'loading',
					loading:false,
					type:this.modelData.type
				})
				if(res.errcode != 0) return;
				row.disabled = true;
				this.$notify.success('新增成功');
				this.$emit('getList')
				this.$emit('getHolidayList')
			})
		},
		/* 添加时间策略 */
        onAdd(){
			let index = this.modelData.tableData.findIndex(el => !el.disabled);
			if(index != -1) return this.$notify.warning('请先保存您正在编辑的数据');
			Object.keys(this.modelData.initForm).map(item => {
				this.modelData.initForm[item] = '';
			})
			this.modelData.initForm['disabled'] = false;
			this.modelData.tableData.push(this.modelData.initForm)
        },
		getWorkdayWeek(data){
			if(data[0][0] == 'week'){
				let compareArr = [];
				let result = [];
				const apiList = ['1','2','3','4','5','6','7'];//['周日'....'周六']
				data.map(item => {
					compareArr.push(item[1])
				})
				apiList.map(item => {
					if(compareArr.includes(item)){
						result.push(1)
					}else{
						result.push(0)
					}
				})
				return result.length > 0 ? result.join('|') : '';
			}
			return '1|1|1|1|1|1|1'
		},
        csacaderScopeChange(val,row){
				let changeFlag=false;
			    let  changeItem=null;
				if(this.shareScopeEnd.length===0){
					row.workdayWeek = val;
				}
				else{
					//与原数组比对
					row.workdayWeek.forEach((item)=>{
					//与原数组的类型相同
						if(item[0]!==this.shareScopeEnd[0][0]){
							changeFlag = true;
							changeItem=item;
						}
					});
				}
				if(changeFlag){
				  //上次是system,那么这次是domain
					if(this.shareScopeEnd[0][0]==='8'){
						row.workdayWeek =row.workdayWeek.filter((item)=>{
							 return (item[0]!== '8');
						  });
					}else{
						row.workdayWeek=[];
						row.workdayWeek.push(changeItem);
					}
				}
				this.shareScopeEnd = row.workdayWeek;

		},
		httpRequestFile(file,row){
			if((file?.file?.size / 1024 / 1024) > 10) {
				this.$message.error('附件大于10M，请重新上传');
				return;
			}
			if (file?.file?.type != 'audio/wav') {
			    this.$message.error('上传文件只能是 WAV 格式!');
				return;
			}
			row.file = file.file;
		},
		handleClose(row){
			row.file = '';
		}
    }
}
</script>
<style lang="scss" scoped>
.tel-skillgroup-edit {
    margin-top: 10px;
    ::v-deep {
        .el-form-item {
           margin: 18px 0;
        }
    }
	.upload-demo-item {
		::v-deep {
			.el-form-item__error {
				display: inline-block;
				width: 100%;
				text-align: center;
			}
		}
	}
}
</style>